import React, {Component, Fragment,} from 'react'
import {Collapse, Icon, Button,} from 'antd'
import './index2.less';
import OrderFileComponent from "../../components/bus/order-file";
import {baseUrl, reqVehicleCheck,} from "../../api";
import {DELIVERY_TYPE_MIX, DELIVERY_TYPE_AIR} from "../../utills/constants";
const {Panel} = Collapse;

export default class OrderBoxFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderId: "",
            downloadFile: {},
        }
    }

    componentDidMount() {
        if (this.props.location.state) {
            let orderId = this.props.location.state.orderId;
            this.vehicleCheck(orderId);
            this.setState({orderId})
        }
    }

    download = async () => {
        const url = baseUrl + "/api/v1/p/file/boxFileDownload?orderId=" + this.state.orderId;
        window.open(url, "_blank");
    };
    getChildrenMsg = (objType, length) => {
        this.setState({[objType]: length})
    };
    genExtra = (objType) => {
        if (this.state[objType] > 0) {
            return <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" onClick={event => {
                event.stopPropagation();
            }}/>
        } else {
            return <Icon type="edit" onClick={event => {
                event.stopPropagation();
            }}/>
        }
    };
    exportModel = (type) => {
        const {orderId} = this.state;
        let url;
        switch (type) {
            case 1:
                url = baseUrl + "/api/v1/p/mms/vehicleFile?orderId=" + orderId;
                break;
            case 2:
                url = baseUrl + "/api/v1/p/mms/wayBillExport?orderId=" + orderId;
                break;
            case 3:
                url = baseUrl + "/api/v1/p/mms/cabinFile?orderId=" + orderId;
                break;
            case 4:
                url = baseUrl + "/api/v1/p/mms/caseNumFile?orderId=" + orderId;
                break;
            default:
                break;
        }
        window.open(url, "_blank");
    }
    vehicleCheck = async (orderId) => {
        let result = await reqVehicleCheck(orderId);
        if (result.code === 200) {
            this.setState({downloadFile: result.data})
        }
    }

    render() {
        const customPanelStyle = {
            background: '#fff',
        };
        const {boxVehicle, boxDelivery, boxReturn, downloadFile, boxWeight, orderId, deliveryType} = this.state;
        return (
            <Fragment>
                <Button type='primary' onClick={this.download}
                        disabled={!(boxVehicle > 0 || boxDelivery > 0 || boxReturn > 0 || boxWeight > 0 )}>一键下载</Button>
                <Collapse bordered={false} defaultActiveKey={['1', '2', '3', '4', '5', '6', '7', '8', '9']}>
                    {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ? null :
                        <Panel header="提箱单" key="1" style={customPanelStyle} extra={this.genExtra("boxPickup")}>
                            <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                                getChildrenMsg={this.getChildrenMsg} objectType={"boxPickup"}/>
                        </Panel>}
                    <Panel header="随车资料" key="1" style={customPanelStyle} extra={this.genExtra("boxVehicle")}>
                        <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                            getChildrenMsg={this.getChildrenMsg} objectType={"boxVehicle"}/>
                        <Button className='margin-btn' onClick={e => this.exportModel(1)}
                                disabled={downloadFile.vehicleFlag != 0}>下载随车文件</Button>
                        <Button className='margin-btn' onClick={e => this.exportModel(2)}
                                disabled={downloadFile.wayBillFlag != 0}>下载运单模板</Button>
                        <Button className='margin-btn' onClick={e => this.exportModel(3)}
                                disabled={downloadFile.cabinFlag != 0}>下载舱单文件</Button>
                        <Button className='margin-btn' onClick={e => this.exportModel(4)}
                                disabled={downloadFile.caseNumFlag != 0}>下载箱号信息</Button>
                    </Panel>
                    <Panel header="运单" key="3" style={customPanelStyle} extra={this.genExtra("boxDelivery")}>
                        <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                            getChildrenMsg={this.getChildrenMsg} objectType={"boxDelivery"}/>
                    </Panel>
                    {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ? null :
                        <Panel header="还箱文件" key="4" style={customPanelStyle} extra={this.genExtra("boxReturn")}>
                            <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                                getChildrenMsg={this.getChildrenMsg} objectType={"boxReturn"}/>
                        </Panel>}
                    {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) ?
                        <Panel header="提重文件" key="5" style={customPanelStyle} extra={this.genExtra("boxWeight")}>
                            <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                                getChildrenMsg={this.getChildrenMsg} objectType={"boxWeight"}/>
                        </Panel> : null}
                    <Panel header="T1文件" key="6" style={customPanelStyle} extra={this.genExtra("boxT1")}>
                        <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                            getChildrenMsg={this.getChildrenMsg} objectType={"boxT1"}/>
                    </Panel>
                    <Panel header="报关文件" key="7" style={customPanelStyle} extra={this.genExtra("declare")}>
                        <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                            getChildrenMsg={this.getChildrenMsg} objectType={"declare"}/>
                    </Panel>
                    {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                        <Panel header="提单" key="9" style={customPanelStyle} extra={this.genExtra("boxBillLading")}>
                            <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                                getChildrenMsg={this.getChildrenMsg} objectType={"boxBillLading"}/>
                        </Panel> : null}
                    <Panel header="历史未归类文件" key="8" style={customPanelStyle}>
                        <OrderFileComponent orderId={orderId} {...this.props} readonly={true}
                                            objectType={"box"}/>
                    </Panel>
                </Collapse>
            </Fragment>
        )
    }
}